import {DoubleColorLogo, LogoSvgCommon, PleoHomeLogo} from '@repo/ui/SVGR';
import styled from 'styled-components';
import { gsap, useGSAP } from '@repo/utils/gsap';
import {useRef} from 'react';
import {useQueryElement, useIsDesktop, useMenuColor, useScrollContext} from '@repo/ui';
import {useDispatch, useSelector} from 'react-redux';
import { setSelectedItem, setSelectedSubItem } from '@/state/menuSlice';
import { useRouter } from 'next/router';
import { CURSOR_TYPES } from "@repo/utils/constants";

const StyledWrapper = styled.div`
	cursor: pointer;
    height: 33px;
	width: ${(props) => `${props.width}px`};
    position: relative;
    transform: scale(0.8);
    transform-origin: 0 100%;
    @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
        transform: unset;
    }
`;

const StyledAnimationWrapper = styled.span`
    display: block;
    transition: color var(--color-transition-duration) var(--ease) transform 0.3s;
`

const StyledLogoWrapper = styled.div`
	position: absolute;
	cursor: pointer;
	overflow: hidden;
	width: ${(props) => `${props.width}px`};
    //background-color: inherit;
    z-index: 2;
`;

const StyledHomeWrapper = styled.div`
	position: absolute;
	z-index: 1;
    opacity: 1;
`;

const Logo = ({ firstMenuItem }) => {
    const { open } = useSelector((state) => state.menu);
    const dispatch = useDispatch();
    const router = useRouter();
    const isDesktop = useIsDesktop();
    const logoSvgWidth = useQueryElement('#logo-svg')?.clientWidth || 200;
    const wrapperRef = useRef(null);
    const tl = useRef(null);
    const svgColor = useMenuColor()
    const { instance: { __lenis } } = useScrollContext()

    useGSAP(
        () => {
            const svgPaths = gsap.utils.toArray('.pleo-home-logo-path')
            gsap.set(svgPaths, { opacity: 0 });

            if (!isDesktop) return;
            tl.current = gsap.timeline({ paused: true });
            tl.current.to('.logo-wrapper', { width: 0,  ease: 'none', duration: 0.2 },0);
            tl.current.to(svgPaths, { opacity: 1, stagger: 0.1, duration: 0.1}, 0)
        },
        { scope: wrapperRef, dependencies: [isDesktop] },
    );

    const handleOnClick = () => {
        dispatch(setSelectedSubItem(null))
        if (router.asPath === '/') {
            if (open) {
                __lenis.scrollTo(0)
                router.push('/', '/', { scroll: false });
            } else {
                __lenis.scrollTo(0)
            }
        } else {
            router.push('/', '/', { scroll: false });
        }
    };

    return (
        <StyledWrapper
            onClick={handleOnClick}
            ref={wrapperRef}
            onMouseEnter={() => {
                if (!isDesktop) return
                dispatch(setSelectedItem(firstMenuItem))
                tl.current.play()
            }}
            onMouseLeave={() => isDesktop && tl.current.reverse()}
            width={logoSvgWidth}
            data-cursor={CURSOR_TYPES.LINK}
        >
            <StyledAnimationWrapper className='underline-animation'>
                <StyledLogoWrapper className="logo-wrapper" width={logoSvgWidth}>
                    {open ? <DoubleColorLogo color={svgColor} /> : <LogoSvgCommon color={svgColor} />}
                </StyledLogoWrapper>
                <StyledHomeWrapper className="home-wrapper">
                    <PleoHomeLogo />
                </StyledHomeWrapper>
            </StyledAnimationWrapper>
        </StyledWrapper>
    );
};

export default Logo;
